<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_ix"><span class="bb">Illustrations</span></a></p><a id="page_ix">
</a><p class="tocill"><a id="page_ix"></a><span href="#/xhtml/03_Fm01#fig1" title="Link target outside of Sample"><i>Last Words of Captain Nathan Hale</i> | frontispiece</span></p>
<p class="tocill"><a href="#/xhtml/11_Fm03#fig2"><i>The Battle-Fields of South Carolina 1775–1780</i></a></p>
<p class="tocill"><a href="#/xhtml/13_Part01#fig3">Sir Henry Clinton, engraving</a></p>
<p class="tocill"><a href="#/xhtml/14_Chapter01#fig4"><i>The most Noble Marquis Cornwallis, K.G</i></a>.</p>
<p class="tocill"><span href="#/xhtml/15_Chapter02#fig5" title="Link target outside of Sample"><i>David Ramsay, M.D</i></span>.</p>
<p class="tocill"><span href="#/xhtml/15_Chapter02#fig6" title="Link target outside of Sample"><i>Francis Lord Rawdon</i></span></p>
<p class="tocill"><span href="#/xhtml/16_Chapter03#fig7" title="Link target outside of Sample">Colleton District, South Carolina/A Map of South Carolina and a Part of Georgia</span></p>
<p class="tocill"><span href="#/xhtml/17_Part02#fig8" title="Link target outside of Sample"><i>Isaac Hayne, Carolina Patriot</i></span></p>
<p class="tocill"><span href="#/xhtml/18_Chapter04#fig9" title="Link target outside of Sample"><i>Richard Hutson, Member of the Continental Congress</i></span></p>
<p class="tocill"><span href="#/xhtml/18_Chapter04#fig10" title="Link target outside of Sample">The grave of Elizabeth Hutson Hayne</span></p>
<p class="tocill"><span href="#/xhtml/19_Chapter05#fig11" title="Link target outside of Sample"><i>Capture of Hayne and Death of M’Laughlin</i></span></p>
<p class="tocill"><span href="#/xhtml/19_Chapter05#fig12" title="Link target outside of Sample">The Royal Exchange and Customs House</span></p>
<p class="tocill"><span href="#/xhtml/19_Chapter05#fig13" title="Link target outside of Sample"><i>The Unfortunate Death of Major André</i></span></p>
<p class="tocill"><span href="#/xhtml/19_Chapter05#fig14" title="Link target outside of Sample"><i>Isaac Hayne Being Led from the Exchange to the Scaffold</i></span></p>
<p class="tocill"><span href="#/xhtml/20_Chapter06#fig15" title="Link target outside of Sample">The grave of Col. Isaac Hayne</span></p>
<p class="tocill"><span href="#/xhtml/20_Chapter06#fig16" title="Link target outside of Sample">Nathanael Greene, engraving</span></p>
<p class="tocill"><span href="#/xhtml/21_Chapter07#fig17" title="Link target outside of Sample">Lt. Col. Nisbet Balfour’s dispatch</span></p>
<p class="tocill"><span href="#/xhtml/22_Part03#fig18" title="Link target outside of Sample"><i>Francis Lord Rawdon, Marquis of Hastings</i></span></p>
<p class="tocill"><span href="#/xhtml/23_Chapter08#fig19" title="Link target outside of Sample">The Hayne family cemetery</span></p>
<p class="tocill"><span href="#/xhtml/24_Chapter09#fig20" title="Link target outside of Sample">The Isaac Hayne monument</span></p>
<p class="tocill"><span href="#/xhtml/25_Chapter10#fig21" title="Link target outside of Sample">Fictionalized portrait of Lt. Colonel Nisbet Balfour</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_ListofIll.vue?78d4e59a